export const notificationStatuses = {
    Pending: '處理中／可能中斷', Evaluated: '評估完成', Accepted: 'API／SMTP 已接受',
    Failed: '失敗', Skipped: '未啟用／略過', Suppressed: '冷卻／額度抑制', Unknown: '結果未確認'
};

export function formatLogJson(value) {
    if (!value) return '';
    try { return JSON.stringify(JSON.parse(value), null, 2); } catch { return value; }
}

export function formatLogTime(value) {
    if (!value) return '—';
    // SQL DateTime values may be returned without a suffix; audit dates are always UTC.
    const date = new Date(/[zZ]|[+-]\d{2}:\d{2}$/.test(value) ? value : value + 'Z');
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export function makeLogFilters(filters, page) {
    const from = parseFilterDate(filters.from);
    const to = parseFilterDate(filters.to, true);
    if ((from && Number.isNaN(from.getTime())) || (to && Number.isNaN(to.getTime()))) throw new Error('日期格式無效。');
    if (from && to && from > to) throw new Error('開始時間不能晚於結束時間。');
    return { ...filters, from: from?.toISOString() || '', to: to?.toISOString() || '', page, pageSize: 25 };
}

function parseFilterDate(value, endOfDay = false) {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day)
            throw new Error('日期格式無效。');
        if (endOfDay) date.setHours(23, 59, 59, 999);
        return date;
    }
    return new Date(value);
}

export function defaultLogDateRange(now = new Date()) {
    const format = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return {
        from: format(new Date(now.getFullYear(), now.getMonth() - 2, 1)),
        to: format(new Date(now.getFullYear(), now.getMonth() + 1, 0))
    };
}

export function logQueryString(filters) {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value)) value.forEach(item => query.append(key, item));
        else if (value !== '' && value !== null && value !== undefined) query.append(key, value);
    });
    return query.toString();
}
